import { createClient } from '@supabase/supabase-js';
import { supabaseRuntime } from '@/config/featureFlags';

const supabaseUrl = supabaseRuntime.url;
const supabaseAnonKey = supabaseRuntime.anonKey;
// const supabasePubKey = process.env.VUE_APP_SUPABASE_PUB_KEY;

// 检查必要的环境变量是否存在
const missingVars = [];
if (!supabaseUrl) missingVars.push('VUE_APP_SUPABASE_URL');
// if (!supabasePubKey) missingVars.push('VUE_APP_SUPABASE_PUB_KEY');
if (!supabaseAnonKey) missingVars.push('VUE_APP_SUPABASE_ANON_KEY');
if (missingVars.length > 0) {
    throw new Error(
        `Missing Supabase environment variables: ${missingVars.join(', ')}. Please check your .env file.`
    );
}

// export const supabase = createClient(supabaseUrl, supabasePubKey, {
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,     // 启用会话持久化（默认为 true）
        storageKey: 'photoscope-auth',  // 自定义存储键名
        storage: window.localStorage,    // JWT 存储在 localStorage 中
        autoRefreshToken: true,         // 自动刷新 token
        detectSessionInUrl: true,       // 检测 URL 中的会话信息
    }
});

// 设置认证状态变化监听
// supabase.auth.onAuthStateChange((event, _session) => {
//     console.log('Auth state changed:', event);
// });